import { jsx as r } from "react/jsx-runtime";
import { StyledDatePicker as i } from "./styles.js";
import { DatePickerNav as n } from "./DatePickerNav/DatePickerNav.js";
import { useLocalisation as s } from "../../utils/hooks/useLocalisation.js";
const d = ({
  ...e
}) => {
  const { firstDayOfWeek: t } = s(), o = e.mode === "single" ? e.selected : e.selected?.from;
  return /* @__PURE__ */ r(
    i,
    {
      weekStartsOn: t,
      showOutsideDays: !0,
      defaultMonth: o,
      components: {
        Caption: n
      },
      ...e
    }
  );
};
export {
  d as BaseDatePicker
};
//# sourceMappingURL=BaseDatePicker.js.map
